import ApiService from "./ApiService";
import GeneralUtils from '../utilities/GeneralUtils';
import ApiUtils from "../utilities/ApiUtils";

export class CompetitionService {

    async getCompetitionsByCriteria(criteria) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance()
                .post(`/competition/list`, criteria)
                .then((response) => {
                    response.data.competitions.map(item => {
                        item.startDate = new Date(Date.parse(item.startDate));
                        item.submitEndDate = item.submitEndDate ? new Date(Date.parse(item.submitEndDate)) : '';
                        item.writtenTestDate = item.writtenTestDate ? new Date(Date.parse(item.writtenTestDate)) : '';
                        item.interviewTestDate = item.interviewTestDate ? new Date(Date.parse(item.interviewTestDate)) : '';
                        item.supplementaryTest1Date = item.supplementaryTest1Date ? new Date(Date.parse(item.supplementaryTest1Date)) : '';
                        item.supplementaryTest2Date = item.supplementaryTest2Date ? new Date(Date.parse(item.supplementaryTest2Date)) : '';
                        item.supplementaryTest3Date = item.supplementaryTest3Date ? new Date(Date.parse(item.supplementaryTest3Date)) : '';
                        return item;
                    })
                    resolve(response.data)
                })
                .catch((error) => {
                    let errorMessage = 'generic.error.get.data';
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                    reject(errorMessage);
                });
        });
    }

    async getCompetitionsJobByCriteria(criteria) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance()
                .post(`/competition/job/list`, criteria)
                .then((response) => {
                    response.data.competitions.map(item => {
                        item.startDate = item.startDate ? new Date(Date.parse(item.startDate)) : '';
                        item.submitEndDate = item.submitEndDate ? new Date(Date.parse(item.submitEndDate)) : '';
                        item.writtenTestDate = item.writtenTestDate ? new Date(Date.parse(item.writtenTestDate)) : '';
                        item.interviewTestDate = item.interviewTestDate ? new Date(Date.parse(item.interviewTestDate)) : '';
                        item.supplementaryTest1Date = item.supplementaryTest1Date ? new Date(Date.parse(item.supplementaryTest1Date)) : '';
                        item.supplementaryTest2Date = item.supplementaryTest2Date ? new Date(Date.parse(item.supplementaryTest2Date)) : '';
                        item.supplementaryTest3Date = item.supplementaryTest3Date ? new Date(Date.parse(item.supplementaryTest3Date)) : '';
                        item.institutionRegistrationDate = item.institutionRegistrationDate ? new Date(Date.parse(item.institutionRegistrationDate)) : '';
                        return item;
                    })
                    resolve(response.data)
                })
                .catch((error) => {
                    let errorMessage = 'generic.error.get.data';
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                    reject(errorMessage);
                });
        });
    }

    async getCompetition(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().get(`/competition/${competitionId}`)
                .then(response => {
                    response.data.startDate = response.data.startDate ? new Date(Date.parse(response.data.startDate)) : '';
                    response.data.submitEndDate = response.data.submitEndDate ? new Date(Date.parse(response.data.submitEndDate)) : '';
                    response.data.writtenTestDate = response.data.writtenTestDate ? new Date(Date.parse(response.data.writtenTestDate)) : '';
                    response.data.interviewTestDate = response.data.interviewTestDate ? new Date(Date.parse(response.data.interviewTestDate)) : '';
                    response.data.supplementaryTest1Date = response.data.supplementaryTest1Date ? new Date(Date.parse(response.data.supplementaryTest1Date)) : '';
                    response.data.supplementaryTest2Date = response.data.supplementaryTest2Date ? new Date(Date.parse(response.data.supplementaryTest2Date)) : '';
                    response.data.supplementaryTest3Date = response.data.supplementaryTest3Date ? new Date(Date.parse(response.data.supplementaryTest3Date)) : '';
                    response.data.registrationDate = response.data.registrationDate ? new Date(Date.parse(response.data.registrationDate)) : '';
                    response.data.institutionRegistrationDate = response.data.institutionRegistrationDate ? new Date(Date.parse(response.data.institutionRegistrationDate)) : '';
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async getCompetitionDetails(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().get(`/competition/${competitionId}/details`)
                .then(response => {
                    response.data.startDate = response.data.startDate ? new Date(Date.parse(response.data.startDate)) : '';
                    response.data.submitEndDate = response.data.submitEndDate ? new Date(Date.parse(response.data.submitEndDate)) : '';
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async saveCompetition(competition) {
        competition.supplementaryTest1Name = competition.supplementaryTest1Name ? competition.supplementaryTest1Name : null
        competition.supplementaryTest2Name = competition.supplementaryTest2Name ? competition.supplementaryTest2Name : null
        competition.supplementaryTest3Name = competition.supplementaryTest3Name ? competition.supplementaryTest3Name : null
        competition.description = competition.description ? competition.description : null
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post('/competition', competition)
                .then(response => {
                    response.data.startDate = new Date(Date.parse(response.data.startDate));
                    response.data.submitEndDate = response.data.submitEndDate ? new Date(Date.parse(response.data.submitEndDate)) : '';
                    response.data.writtenTestDate = response.data.writtenTestDate ? new Date(Date.parse(response.data.writtenTestDate)) : '';
                    response.data.interviewTestDate = response.data.interviewTestDate ? new Date(Date.parse(response.data.interviewTestDate)) : '';
                    response.data.supplementaryTest1Date = response.data.supplementaryTest1Date ? new Date(Date.parse(response.data.supplementaryTest1Date)) : '';
                    response.data.supplementaryTest2Date = response.data.supplementaryTest2Date ? new Date(Date.parse(response.data.supplementaryTest2Date)) : '';
                    response.data.supplementaryTest3Date = response.data.supplementaryTest3Date ? new Date(Date.parse(response.data.supplementaryTest3Date)) : '';
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.save.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async saveCompetitionJob(competition) {
        let _competition = GeneralUtils.nullIfEmptyForObjectFields(competition);
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post('/competition/job', _competition)
                .then(response => {
                    response.data.startDate = response.data.startDate ? new Date(Date.parse(response.data.startDate)) : '';
                    response.data.submitEndDate = response.data.submitEndDate ? new Date(Date.parse(response.data.submitEndDate)) : '';
                    response.data.writtenTestDate = response.data.writtenTestDate ? new Date(Date.parse(response.data.writtenTestDate)) : '';
                    response.data.interviewTestDate = response.data.interviewTestDate ? new Date(Date.parse(response.data.interviewTestDate)) : '';
                    response.data.supplementaryTest1Date = response.data.supplementaryTest1Date ? new Date(Date.parse(response.data.supplementaryTest1Date)) : '';
                    response.data.supplementaryTest2Date = response.data.supplementaryTest2Date ? new Date(Date.parse(response.data.supplementaryTest2Date)) : '';
                    response.data.supplementaryTest3Date = response.data.supplementaryTest3Date ? new Date(Date.parse(response.data.supplementaryTest3Date)) : '';
                    response.data.institutionRegistrationDate = response.data.institutionRegistrationDate ? new Date(Date.parse(response.data.institutionRegistrationDate)) : '';
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.save.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async saveCompetitionJobCalendar(competition) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post('/competition/job/calendar', competition)
                .then(response => {
                    // console.log("saveCompetitionJobCalendar: ", response.data.competition)
                    response.data.competition.startDate = response.data.competition.startDate ? new Date(Date.parse(response.data.competition.startDate)) : '';
                    response.data.competition.submitEndDate = response.data.competition.submitEndDate ? new Date(Date.parse(response.data.competition.submitEndDate)) : '';
                    response.data.competition.writtenTestDate = response.data.competition.writtenTestDate ? new Date(Date.parse(response.data.competition.writtenTestDate)) : '';
                    resolve(response.data)
                })
                .catch(error => {
                    reject(ApiUtils.computeCheckErrorArray(error))
                })
        })
    }

    async saveCompetitionJobExam(exam) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post('/competition/job/exam', exam)
                .then(response => {
                    // console.log("saveCompetitionJobCalendar: ", response.data.competition)
                    response.data.competitionCalendar.examDate = response.data.competitionCalendar.examDate ? new Date(Date.parse(response.data.competitionCalendar.examDate)) : '';
                    response.data.competitionCalendar.resultsDate = response.data.competitionCalendar.resultsDate ? new Date(Date.parse(response.data.competitionCalendar.resultsDate)) : '';
                    response.data.competitionCalendar.contestationDate = response.data.competitionCalendar.contestationDate ? new Date(Date.parse(response.data.competitionCalendar.contestationDate)) : '';
                    response.data.competitionCalendar.contestationValidationDate = response.data.competitionCalendar.contestationValidationDate ? new Date(Date.parse(response.data.competitionCalendar.contestationValidationDate)) : '';
                    resolve(response.data)
                })
                .catch(error => {
                    reject(ApiUtils.computeCheckErrorArray(error))
                })
        })
    }

    async deleteCompetition(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().delete(`/competition/${competitionId}`)
                .then(resolve)
                .catch(error => {
                    let errorMessage = "generic.delete.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                    reject(errorMessage);
                })
        })
    }

    async getMyAvailableCompetitionListByCriteria(criteria) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance()
                .post(`/competition/available`, criteria)
                .then((response) => {
                    response.data.competitions.map(item => {
                        item.startDate = new Date(Date.parse(item.startDate));
                        item.submitEndDate = item.submitEndDate ? new Date(Date.parse(item.submitEndDate)) : '';
                        item.writtenTestDate = item.writtenTestDate ? new Date(Date.parse(item.writtenTestDate)) : '';
                        item.interviewTestDate = item.interviewTestDate ? new Date(Date.parse(item.interviewTestDate)) : '';
                        item.supplementaryTest1Date = item.supplementaryTest1Date ? new Date(Date.parse(item.supplementaryTest1Date)) : '';
                        item.supplementaryTest2Date = item.supplementaryTest2Date ? new Date(Date.parse(item.supplementaryTest2Date)) : '';
                        item.supplementaryTest3Date = item.supplementaryTest3Date ? new Date(Date.parse(item.supplementaryTest3Date)) : '';
                        return item;
                    })
                    resolve(response.data)
                })
                .catch((error) => {
                    let errorMessage = 'generic.error.get.data';
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                    reject(errorMessage);
                });
        });
    }

    // competition test centers

    async getTestCenterRoomList(competitionId, status) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().get(`/competition/${competitionId}/testCenterRooms${status ? '?status=' + status : ''}`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async getTestCenters(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().get(`/competition/${competitionId}/testCenters`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async getTestCenterRooms(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().get(`/competition/${competitionId}/rooms`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async saveCompetitionTestCenterRoom(competitionTestCenter) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post('/competition/testCenterRoom', competitionTestCenter)
                .then(response => {
                    response.data.startDate = response.data.startDate ? new Date(Date.parse(response.data.startDate)) : '';
                    response.data.submitEndDate = response.data.submitEndDate ? new Date(Date.parse(response.data.submitEndDate)) : '';
                    resolve(GeneralUtils.emptyInNullForObjectFields(response.data))
                })
                .catch(error => {
                    let errorMessage = "generic.save.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async updateCompetitionTestCenterRooms(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().put(`/competition/${competitionId}/updateRooms`, competitionId)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.save.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    // competition test

    async getCompetitionTestList(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().get(`/competition/${competitionId}/tests`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async saveCompetitionTest(competitionTest) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post('/competition/test', competitionTest)
                .then(response => {
                    response.data.startDate = response.data.startDate ? new Date(Date.parse(response.data.startDate)) : '';
                    response.data.submitEndDate = response.data.submitEndDate ? new Date(Date.parse(response.data.submitEndDate)) : '';
                    resolve(GeneralUtils.emptyInNullForObjectFields(response.data))
                })
                .catch(error => {
                    let errorMessage = "generic.save.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async updateCompetitionTestsOrder(competitionTests) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().put(`/competition/tests`, competitionTests)
                .then(response => {
                    response.data.map(item => {
                        return GeneralUtils.emptyInNullForObjectFields(item)
                    })
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.save.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async deleteCompetitionTest(competitionId, competitionTestId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().delete(`/competition/${competitionId}/test/${competitionTestId}`)
                .then(resolve)
                .catch(error => {
                    let errorMessage = "generic.delete.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async publishResults(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post(`/competition/${competitionId}/publishResults`)
                .then(response => {
                    response.data.startDate = response.data.startDate ? new Date(Date.parse(response.data.startDate)) : '';
                    response.data.submitEndDate = response.data.submitEndDate ? new Date(Date.parse(response.data.submitEndDate)) : '';
                    resolve(GeneralUtils.emptyInNullForObjectFields(response.data))
                })
                .catch(error => {
                    let errorMessage = "generic.save.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async getCompetitionListForEvaluationByCriteria(criteria) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance()
                .post(`/competition/list/evaluation`, criteria)
                .then((response) => {
                    response.data.competitions.map(item => {
                        item.startDate = new Date(Date.parse(item.startDate));
                        item.submitEndDate = item.submitEndDate ? new Date(Date.parse(item.submitEndDate)) : '';
                        item.writtenTestDate = item.writtenTestDate ? new Date(Date.parse(item.writtenTestDate)) : '';
                        item.interviewTestDate = item.interviewTestDate ? new Date(Date.parse(item.interviewTestDate)) : '';
                        item.supplementaryTest1Date = item.supplementaryTest1Date ? new Date(Date.parse(item.supplementaryTest1Date)) : '';
                        item.supplementaryTest2Date = item.supplementaryTest2Date ? new Date(Date.parse(item.supplementaryTest2Date)) : '';
                        item.supplementaryTest3Date = item.supplementaryTest3Date ? new Date(Date.parse(item.supplementaryTest3Date)) : '';
                        item.registrationDate = item.registrationDate ? new Date(Date.parse(item.registrationDate)) : '';
                        return item;
                    })
                    resolve(response.data)
                })
                .catch((error) => {
                    let errorMessage = 'generic.error.get.data';
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                    reject(errorMessage);
                });
        });
    }

    async getCompetitionResultByType(criteria) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post(`/competition/application/result`, criteria)
                .then((response) => {
                    resolve({ results: response.data.items, totalCount: response.data.totalCount })
                })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message && error.response.data.status !== 404) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async distributeCandidates(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post(`/competition/${competitionId}/distributeCandidatesToTestSessions`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.save.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async getTestSessionsStatistics(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().get(`/competition/${competitionId}/testSessionsStatistics`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.save.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async getApplicationsTestSessionsAndTestCenters(criteria) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post(`/competition/applicationsTestSessions`, criteria)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async getApplicationsTestSessions(competitionId, testSessionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().get(`/competition/${competitionId}/testSessions/${testSessionId}/applications`)
                .then(response => {
                    response.data.map(item => {
                        item.startDate = new Date(Date.parse(item.startDate));
                        item.endDate = new Date(Date.parse(item.endDate));
                        return item;
                    })
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.save.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async updateApplicationTestSessionPresence(applicationTestSessionId, isPresent, isCanceled, extendedTime) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().put(`/applicationTestSession/presence`,
                { id: applicationTestSessionId, isPresent: isPresent, isCanceled: isCanceled, extendedTime: extendedTime }
            )
                .then(response => {
                    response.data.startDate = response.data.startDate ? new Date(Date.parse(response.data.startDate)) : '';
                    response.data.endDate = response.data.endDate ? new Date(Date.parse(response.data.endDate)) : '';
                    resolve(GeneralUtils.emptyInNullForObjectFields(response.data))
                })
                .catch(error => {
                    let errorMessage = "generic.save.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async generateApplicationTestsUrls(applicationTestSessionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().put(`/applicationTestSession/generateTestUrls`, { id: applicationTestSessionId })
                .then(response => {
                    response.data.startDate = response.data.startDate ? new Date(Date.parse(response.data.startDate)) : '';
                    response.data.endDate = response.data.endDate ? new Date(Date.parse(response.data.endDate)) : '';
                    resolve(GeneralUtils.emptyInNullForObjectFields(response.data))
                })
                .catch(error => {
                    let errorMessage = "generic.save.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async getAvailableTestCenters(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().get(`/competition/${competitionId}/availableTestCenters`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.save.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async getAvailableSessions(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().get(`/competition/${competitionId}/availableTestSessions`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.save.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async getClarifications(criteria) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post(`/competition/clarifications`, criteria)
                .then(response => {
                    response.data.items.map((item) => {
                        item.fullName = item.firstName + ' ' + item.lastName;

                        return item;
                    });
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async getContestations(criteria) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post(`/competition/contestations`, criteria)
                .then(response => {
                    response.data.items.map((item) => {
                        item.fullName = item.firstName + ' ' + item.lastName;

                        return item;
                    });
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }


    async moveToNextStatus(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().put(`/competition/${competitionId}/testOnly/moveToNextStatus`)
                .then(response => {
                    response.data.startDate = response.data.startDate ? new Date(Date.parse(response.data.startDate)) : '';
                    response.data.submitEndDate = response.data.submitEndDate ? new Date(Date.parse(response.data.submitEndDate)) : '';
                    resolve(GeneralUtils.emptyInNullForObjectFields(response.data))
                })
                .catch(error => {
                    let errorMessage = "generic.save.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async distributeApplicationsToEvaluators(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().put(`/competition/${competitionId}/distributeApplicationsToEvaluators`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.save.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async getCommitteeListForClarifications(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance()
                .get(`/competition/${competitionId}/committees/clarifications`)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    let errorMessage = 'generic.error.get.data';
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                    reject(errorMessage);
                });
        });
    }

    async finishTestSessionsDistribution(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post(`/competition/${competitionId}/finishTestSessionDistributions`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.save.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async enableTestSessionsChoose(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post(`/competition/${competitionId}/enableSessionsChoose`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.save.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async getFinalReportCompetitionList() {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().get('/competition/final-report/list')
                .then(response => {
                    let canEdit = false
                    if (response.data && response.data.length > 0) {
                        response.data.forEach(item => {
                            canEdit = !canEdit ? item.canEdit : canEdit
                        })

                    }
                    resolve({ data: response.data, canEdit: canEdit })
                })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async saveCompetitionFinalReport(finalReport) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post('/competition/final-report/edit', finalReport)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.save.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }
    async getCompetitionJobs(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance()
                .get(`/competition/${competitionId}/jobs`)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    let errorMessage = 'generic.error.get.data';
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                    reject(errorMessage);
                });
        });
    }

    async endContestationOpenStatus(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post(`/competition/${competitionId}/endContestationOpenStatus`)
                .then(response => {
                    response.data.startDate = response.data.startDate ? new Date(Date.parse(response.data.startDate)) : '';
                    response.data.submitEndDate = response.data.submitEndDate ? new Date(Date.parse(response.data.submitEndDate)) : '';
                    resolve(GeneralUtils.emptyInNullForObjectFields(response.data))
                })
                .catch(error => {
                    let errorMessage = "generic.save.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async getInstitutions(criteria) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post(`/competition/institutions`, criteria)
                .then(response => {
                    let _institutions = []
                    response.data.forEach(element => {
                        _institutions.push({ label: element.name, value: element.id })
                    });

                    resolve(_institutions)
                })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async generateJobCompetition(category) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post(`/competition/generate-job-competition/${category}`)
                .then((response) => resolve(response.data))
                .catch(error => {
                    let errorMessage = "generic.save.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                    reject(errorMessage);
                })
        })
    }

    async getCompetitionCalendar(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().get(`/competition/${competitionId}/job/calendar/list`)
                .then(response => {
                    response.data.map(item => {
                        item.examDate = item.examDate ? new Date(Date.parse(item.examDate)) : '';
                        item.resultsDate = item.resultsDate ? new Date(Date.parse(item.resultsDate)) : '';
                        item.contestationDate = item.contestationDate ? new Date(Date.parse(item.contestationDate)) : '';
                        item.contestationValidationDate = item.contestationValidationDate ? new Date(Date.parse(item.contestationValidationDate)) : '';
                        return item;
                    })
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async getCompetitionCalendarDetails(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().get(`/competition/${competitionId}/job/calendar/details`)
                .then(response => {
                    response.data.map(item => {
                        item.examDate = item.examDate ? new Date(Date.parse(item.examDate)) : '';
                        item.resultsDate = item.resultsDate ? new Date(Date.parse(item.resultsDate)) : '';
                        item.contestationDate = item.contestationDate ? new Date(Date.parse(item.contestationDate)) : '';
                        item.contestationValidationDate = item.contestationValidationDate ? new Date(Date.parse(item.contestationValidationDate)) : '';
                        return item;
                    })
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async deleteCompetitionCalendar(competitionCalendarId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().delete(`/competition/job/exam/${competitionCalendarId}`)
                .then(resolve)
                .catch(error => {
                    let errorMessage = "generic.delete.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                    reject(errorMessage);
                })
        })
    }

    async saveJob(competitionJob) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post('/competition/job/job', competitionJob)
                .then(response => {
                    resolve(response.data.competitionJob)
                })
                .catch(error => {
                    reject(ApiUtils.computeCheckErrorArray(error))
                })
        })
    }

    async deleteJob(jobId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().delete(`/competition/job/job/${jobId}`)
                .then(resolve)
                .catch(error => {
                    let errorMessage = "generic.delete.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                    reject(errorMessage);
                })
        })
    }

    async saveCompetitionAction(competition, action) {
        let _url = ''
        switch (action) {
            case 'VALIDATE':
                _url = '/competition/job/validate';
                break
            case 'UNLOCK':
                _url = '/competition/job/editable';
                break
            case 'RETIRE':
                _url = '/competition/job/retire';
                break
            case 'APPROVE':
                _url = '/competition/job/approve';
                break
            case 'REJECT':
                _url = '/competition/job/reject';
                break
            case 'CANCEL':
                _url = '/competition/job/cancel';
                break
            case 'FINALIZE':
                _url = '/competition/job/finalize';
                break
            default:
                _url = null;
        }

        // console.log('enpoint url: ', _url)

        if (_url) {
            return new Promise((resolve, reject) => {
                ApiService.getAuthenticatedInstance().post(_url, competition)
                    .then(response => {
                        response.data.startDate = response.data.startDate ? new Date(Date.parse(response.data.startDate)) : '';
                        response.data.submitEndDate = response.data.submitEndDate ? new Date(Date.parse(response.data.submitEndDate)) : '';
                        response.data.writtenTestDate = response.data.writtenTestDate ? new Date(Date.parse(response.data.writtenTestDate)) : '';
                        response.data.interviewTestDate = response.data.interviewTestDate ? new Date(Date.parse(response.data.interviewTestDate)) : '';
                        response.data.supplementaryTest1Date = response.data.supplementaryTest1Date ? new Date(Date.parse(response.data.supplementaryTest1Date)) : '';
                        response.data.supplementaryTest2Date = response.data.supplementaryTest2Date ? new Date(Date.parse(response.data.supplementaryTest2Date)) : '';
                        response.data.supplementaryTest3Date = response.data.supplementaryTest3Date ? new Date(Date.parse(response.data.supplementaryTest3Date)) : '';
                        resolve(GeneralUtils.emptyInNullForObjectFields(response.data))
                    })
                    .catch(error => {
                        reject(ApiUtils.computeSaveErrorArray(error))
                    })
            })
        } else {
            return new Promise((resolve, reject) => {
                reject({ errorMessage: ApiUtils.computeSaveError() })
            })
        }
    }

    async getCompetitionChangeReason(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().get(`/competition/${competitionId}/changeReason/list`)
                .then(response => {
                    response.data.map(item => {
                        item.lastModifiedOn = item.lastModifiedOn ? new Date(Date.parse(item.lastModifiedOn)) : '';
                        return item;
                    })
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async getInstitutionsForCompetitionByCriteria(competitionId, criteria) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance()
                .post(`/competition/${competitionId}/institution/list`, criteria)
                .then((response) => {
                    let _institutions = []
                    response.data.forEach(element => {
                        _institutions.push({label: element.name, value: element.id})
                    });            

                    resolve(_institutions) 
                })
                .catch((error) => {
                    let errorMessage = 'generic.error.get.data';
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                    reject(errorMessage);
                });
        });
    }

    async getCompetitionGeneralReq(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().get(`/competition/${competitionId}/generalRequirements/list`)
                .then(response => {
                    response.data.map(item => {
                        return item;
                    })
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async getCompetitionEducationList(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().get(`/competition/${competitionId}/education/list`)
                .then(response => {
                    response.data.map(item => {
                        return item;
                    })
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async saveCompetitionEducation(competitionEducation) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post('/competition/job/education', competitionEducation)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(ApiUtils.computeSaveError(error))
                })
        })
    }

    async deleteCompetitionEducation(competitionEducationId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().delete(`/competition/job/education/${competitionEducationId}`)
                .then(resolve)
                .catch(error => {
                    let errorMessage = "generic.delete.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                    reject(errorMessage);
                })
        })
    }

    async getCompetitionItKnowledgeList(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().get(`/competition/${competitionId}/itKnowledge/list`)
                .then(response => {
                    response.data.map(item => {
                        return item;
                    })
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async saveCompetitionItKnowledge(competitionItKnowledge) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post('/competition/job/itKnowledge', competitionItKnowledge)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(ApiUtils.computeSaveError(error))
                })
        })
    }

    async deleteCompetitionItKnowledge(competitionItKnowledgeId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().delete(`/competition/job/itKnowledge/${competitionItKnowledgeId}`)
                .then(resolve)
                .catch(error => {
                    let errorMessage = "generic.delete.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                    reject(errorMessage);
                })
        })
    }

    async getCompetitionLanguageList(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().get(`/competition/${competitionId}/language/list`)
                .then(response => {
                    response.data.map(item => {
                        return item;
                    })
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async saveCompetitionLanguage(competitionLanguage) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post('/competition/job/language', competitionLanguage)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(ApiUtils.computeSaveError(error))
                })
        })
    }

    async deleteCompetitionLanguage(competitionLanguageId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().delete(`/competition/job/language/${competitionLanguageId}`)
                .then(resolve)
                .catch(error => {
                    let errorMessage = "generic.delete.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                    reject(errorMessage);
                })
        })
    }

    async getCompetitionBibliographyList(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().get(`/competition/${competitionId}/bibliography/list`)
                .then(response => {
                    response.data.map(item => {
                        return item;
                    })
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async saveCompetitionBibliography(competitionBibliography) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post('/competition/job/bibliography', competitionBibliography)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(ApiUtils.computeSaveError(error))
                })
        })
    }

    async deleteCompetitionBibliography(competitionBibliographyId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().delete(`/competition/job/bibliography/${competitionBibliographyId}`)
                .then(resolve)
                .catch(error => {
                    let errorMessage = "generic.delete.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                    reject(errorMessage);
                })
        })
    }

    async getCompetitionDocumentList(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().get(`/competition/${competitionId}/document/list`)
                .then(response => {
                    response.data.map(item => {
                        return item;
                    })
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async saveCompetitionDocument(competitionDocument) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post('/competition/job/document', competitionDocument)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(ApiUtils.computeSaveError(error))
                })
        })
    }

    async deleteCompetitionDocument(competitionDocumentId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().delete(`/competition/job/document/${competitionDocumentId}`)
                .then(resolve)
                .catch(error => {
                    let errorMessage = "generic.delete.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                    reject(errorMessage);
                })
        })
    }

    async getCompetitionCalendarChange(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().get(`/competition/${competitionId}/job/calendarChange/list`)
                .then(response => {
                    response.data.map(item => {
                        item.examDate = item.examDate ? new Date(Date.parse(item.examDate)) : '';
                        item.competitionCalendar.examDate = item.competitionCalendar.examDate ? new Date(Date.parse(item.competitionCalendar.examDate)) : '';
                        return item;
                    })
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async approveCompetitionJobCalendarChange(competitionId, approved) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post(`/competition/${competitionId}/job/calendarChange/approve/${approved}`)
                .then(() => {
                    resolve()
                })
                .catch(error => {
                    reject(ApiUtils.computeSaveError(error))
                })
        })
    }


    async getCompetitionSubjects(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance()
            .get(`/competition/${competitionId}/subjects`)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                let errorMessage = 'generic.error.get.data';
                if (error && error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
                reject(errorMessage);
            });
        });
    }

    async getCompetitionBibliography(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance()
            .get(`/competition/${competitionId}/bibliography`)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                let errorMessage = 'generic.error.get.data';
                if (error && error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
                reject(errorMessage);
            });
        });
    }

    async saveSubject(subject) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance()
            .post('/subject', subject)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                let errorMessage = 'generic.save.error';
                if (error && error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
                reject(errorMessage);
            });
        });
    }

    async deleteSubject(subjectId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance()
            .delete(`/subject/${subjectId}`)
            .then(resolve)
            .catch((error) => {
                let errorMessage = 'generic.delete.error';
                if (error && error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
                reject(errorMessage);
            });
        });
    }

    async saveSubjectProposal(subjectProposal) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance()
            .post('/subjectProposal', subjectProposal)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                let errorMessage = 'generic.save.error';
                if (error && error.response && error.response.data && Array.isArray(error.response.data)) {
                    errorMessage = error.response.data;
                } else if (error && error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
                reject(errorMessage);
            });
        });
    }

    async deleteSubjectProposal(subjectProposalId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance()
            .delete(`/subjectProposal/${subjectProposalId}`)
            .then(resolve)
            .catch((error) => {
                let errorMessage = 'generic.delete.error';
                if (error && error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
                reject(errorMessage);
            });
        });
    }

    async saveQuestion(question) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance()
            .post('/subjectQuestion', question)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                let errorMessage = 'generic.save.error';
                if (error && error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
                reject(errorMessage);
            });
        });
    }

    async deleteQuestion(subjectQuestionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance()
            .delete(`/subjectQuestion/${subjectQuestionId}`)
            .then(resolve)
            .catch((error) => {
                let errorMessage = 'generic.delete.error';
                if (error && error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
                reject(errorMessage);
            });
        });
    }

    async saveQuestionAnswer(answer) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance()
            .post('/subjectQuestionAnswer', answer)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                let errorMessage = 'generic.save.error';
                if (error && error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
                reject(errorMessage);
            });
        });
    }

    async deleteQuestionAnswer(subjectQuestionAnswerId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance()
            .delete(`/subjectQuestionAnswer/${subjectQuestionAnswerId}`)
            .then(resolve)
            .catch((error) => {
                let errorMessage = 'generic.delete.error';
                if (error && error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
                reject(errorMessage);
            });
        });
    }

    async changeSubjectsStructure(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance()
            .post(`/competition/${competitionId}/changeSubjectsStructure`)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                let errorMessage = 'generic.error.get.data';
                if (error && error.response && error.response.data && Array.isArray(error.response.data)) {
                    errorMessage = error.response.data;
                } else if (error && error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
                reject(errorMessage);
            });
        });
    }

    async extractSubjects(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance()
            .post(`/competition/${competitionId}/extractSubjects`)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                let errorMessage = 'generic.error.get.data';
                if (error && error.response && error.response.data && Array.isArray(error.response.data)) {
                    errorMessage = error.response.data;
                } else if (error && error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
                reject(errorMessage);
            });
        });
    }

    async invalidateExtractedSubjects(competitionId, data) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance()
            .post(`/competition/${competitionId}/invalidateExtractedSubjects`, data)
            .then(resolve)
            .catch((error) => {
                let errorMessage = 'generic.save.error';
                if (error && error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
                reject(errorMessage);
            });
        });
    }

    async validateSubjectProposal(subjectProposalId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance()
            .get(`/subjectProposal/${subjectProposalId}/validate`)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                let errorMessage = 'generic.error.get.data';
                if (error && error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
                reject(errorMessage);
            });
        });
    }

    async getCompetitionOtherCompetencyList(competitionId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().get(`/competition/${competitionId}/otherCompetency/list`)
                .then(response => {
                    response.data.map(item => {
                        return item;
                    })
                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async saveCompetitionOtherCompetency(competitionOtherCompetency) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post('/competition/job/otherCompetency', competitionOtherCompetency)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(ApiUtils.computeSaveError(error))
                })
        })
    }

    async deleteCompetitionOtherCompetency(competitionOtherCompetencyId) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().delete(`/competition/job/otherCompetency/${competitionOtherCompetencyId}`)
                .then(resolve)
                .catch(error => {
                    let errorMessage = "generic.delete.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                    reject(errorMessage);
                })
        })
    }
}